"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamblingRiskHandlingDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.GamblingRiskHandlingDescription = {
    priority: 4,
    label: 'fields.payload.mor_group_answers.gambling_risk_handling_description.label',
    fallbackLabel: 'Please specify the presence of dedicated staff equipped to handle sector-specific risks.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_gambling_segment', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_gambling_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_gambling_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
